import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fiveseaterbusonrentinshirdi() {



    const cardData = {





keyword: "50 Seater Bus on Rent in Shirdi",
headingDescription: "Sai Shirdi Cab provides 50 seater bus rental in Shirdi for large-scale group transportation, making it a practical choice for pilgrimage tours, school and college excursions, corporate outings, wedding functions, social events, family vacations, tour groups, and multi-day outstation journeys. A 50 seater bus allows a high number of passengers to travel together in one vehicle, reducing the need for multiple cabs and making group coordination much easier. Sai Shirdi Cab can arrange 50 seater bus hire from Shirdi for one-way travel, round trips, return journeys, sightseeing tours, interstate trips, and customized multi-destination itineraries. Whether your group is planning a religious tour, leisure holiday, educational excursion, or special event outside Shirdi, the bus service can be organized according to your passenger count, route, pickup requirements, and travel schedule.",

topPlaces: [
{
title: "Pune",
description: "Pune is a convenient outstation destination for large groups traveling from Shirdi for corporate visits, educational tours, family functions, events, and sightseeing programs. A 50 seater bus provides sufficient capacity for bigger groups to stay together throughout the journey rather than arranging several smaller vehicles. Sai Shirdi Cab can organize direct or return bus travel with pickup and drop arrangements suited to the group's schedule."
},
{
title: "Saputara",
description: "Saputara is a suitable choice for a large group holiday, weekend excursion, college tour, or family outing from Shirdi. With a 50 seater bus on rent, passengers can travel together comfortably while keeping the entire itinerary under one coordinated transportation plan. Sai Shirdi Cab can arrange the journey for sightseeing, overnight stays, return travel, and customized group tour requirements."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar can be included in a large pilgrimage itinerary beginning from Shirdi, especially when devotees are traveling as an organized group. A 50 seater bus offers the seating capacity needed for larger religious tours and simplifies transportation between destinations. Sai Shirdi Cab can arrange direct trips or combined pilgrimage routes covering Trimbakeshwar and other important destinations."
},
{
title: "Bhandardara",
description: "Bhandardara is an appealing nature destination for large family groups, friends, corporate teams, and organized tour parties departing from Shirdi. Hiring a 50 seater bus allows everyone to remain in the same vehicle while traveling to the destination and exploring the surrounding area. Sai Shirdi Cab can plan transportation for day trips, weekend tours, overnight programs, and return journeys."
},
{
title: "Goa",
description: "Goa is an excellent long-distance option for large groups planning vacations, celebrations, college trips, family holidays, or organized tours from Shirdi. A 50 seater bus is particularly useful for moving a high number of passengers together on an extended journey. Sai Shirdi Cab can arrange one-way, round-trip, or multi-day bus rental with transportation planned around the group's complete Goa itinerary."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is well suited for large pilgrimage groups traveling from Shirdi. A 50 seater bus offers a convenient solution for devotees who want to maintain a common departure, travel route, and return schedule. Sai Shirdi Cab can provide group transportation for temple visits and customized religious tours that include additional destinations in Maharashtra."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a good option for large groups looking for a hill-station vacation from Shirdi. Families, friends, corporate groups, and tour organizers can use a 50 seater bus to manage group transportation without splitting passengers across multiple cars. Sai Shirdi Cab can arrange round-trip or multi-day travel with sightseeing plans tailored to the group's requirements."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves offer a valuable heritage-tour option for school groups, college excursions, families, cultural travelers, and organized tour parties from Shirdi. A 50 seater bus provides ample seating for larger groups and keeps transportation coordinated during a sightseeing itinerary. Sai Shirdi Cab can arrange direct travel or a broader route including historical and religious attractions around Chhatrapati Sambhajinagar."
},
{
title: "Igatpuri",
description: "Igatpuri is a suitable outstation choice for large groups interested in nature, relaxation, weekend travel, and group excursions from Shirdi. A 50 seater bus gives the group a single transportation solution for the journey, making pickup coordination and return planning easier. Sai Shirdi Cab can customize the bus rental according to the group's travel dates, sightseeing plans, and preferred route."
},
{
title: "Nashik",
description: "Nashik is a versatile outstation destination from Shirdi for pilgrimage groups, corporate travelers, family tours, and sightseeing programs. For a larger passenger group, a 50 seater bus makes shared transportation more practical and helps everyone follow the same itinerary. Sai Shirdi Cab can arrange direct Nashik travel or a customized multi-stop journey connecting Nashik with nearby religious and leisure destinations."
}
],









"services": [
{
"name": "50 Seater Bus on Rent in Shirdi",
"description": "50 Seater Bus on Rent in Shirdi is a convenient choice for large groups planning local sightseeing, pilgrimages, family tours, events, and outstation journeys. The vehicle can be arranged based on the travel date, pickup point, destination, passenger requirements, luggage needs, and trip duration."
},
{
"name": "50 Seater Bus Rental Shirdi",
"description": "50 Seater Bus Rental Shirdi provides spacious group transportation for tour groups, families, schools, companies, and event organizers. Customers can plan their journey with suitable pickup and drop points, flexible schedules, and transportation arrangements tailored to their itinerary."
},
{
"name": "50 Seater Bus Hire Shirdi",
"description": "50 Seater Bus Hire Shirdi is suitable for groups that need to travel together in a single spacious vehicle. It can be arranged for sightseeing tours, religious journeys, weddings, corporate outings, school trips, social events, and long-distance travel."
},
{
"name": "50 Seater Tourist Bus Shirdi",
"description": "50 Seater Tourist Bus Shirdi offers a practical travel solution for large groups exploring Shirdi and nearby destinations. The spacious seating capacity makes it suitable for organized sightseeing tours, multi-destination trips, pilgrimage routes, and customized travel itineraries."
},
{
"name": "50 Seater Bus Booking Shirdi",
"description": "50 Seater Bus Booking Shirdi helps travelers organize group transportation for planned journeys and special occasions. Customers can share details such as travel dates, pickup locations, destinations, passenger count, and preferred journey type to arrange suitable transportation."
},
{
"name": "50 Seater Bus with Driver Shirdi",
"description": "50 Seater Bus with Driver Shirdi provides a chauffeur-driven transportation option for large groups traveling together. A dedicated driver can manage the driving and route requirements while passengers enjoy convenient travel for tours, functions, pilgrimages, and outstation journeys."
},
{
"name": "50 Seater Bus for Outstation Shirdi",
"description": "50 Seater Bus for Outstation Shirdi is designed for large groups traveling from Shirdi to cities, tourist destinations, and pilgrimage locations. It can be planned for one-way trips, return journeys, multi-day tours, multiple stops, and customized outstation routes."
},
{
"name": "50 Seater Bus for Family Trip Shirdi",
"description": "50 Seater Bus for Family Trip Shirdi offers comfortable group transportation for extended families and large travel groups. Families can use the spacious vehicle for vacations, sightseeing, religious visits, family functions, and outstation journeys while keeping everyone together."
},
{
"name": "50 Seater Bus for Wedding Shirdi",
"description": "50 Seater Bus for Wedding Shirdi helps families transport wedding guests and relatives between hotels, venues, railway stations, and ceremony locations. It is useful for managing group transfers during weddings, receptions, religious ceremonies, and other related functions."
},
{
"name": "50 Seater Bus for Corporate Trip Shirdi",
"description": "50 Seater Bus for Corporate Trip Shirdi provides group transportation for companies organizing employee outings, conferences, meetings, training programs, corporate events, and business tours. The journey can be coordinated around office schedules, designated pickup points, destinations, and travel requirements."
},
{
"name": "50 Seater Bus for School Trip Shirdi",
"description": "50 Seater Bus for School Trip Shirdi is a suitable option for educational tours, school excursions, field visits, and student outings. Transportation can be organized according to the planned itinerary, pickup locations, destination, number of students and teachers, and travel schedule."
},
{
"name": "50 Seater Bus for Pilgrimage Shirdi",
"description": "50 Seater Bus for Pilgrimage Shirdi provides convenient transportation for large groups of devotees visiting religious destinations. It can be arranged for temple tours, multi-destination pilgrimage programs, group darshan trips, and customized religious journeys from Shirdi."
},
{
"name": "50 Seater Bus for Events Shirdi",
"description": "50 Seater Bus for Events Shirdi helps organizers arrange transportation for guests attending exhibitions, conferences, cultural programs, parties, social gatherings, and other events. Group transfers can be coordinated between hotels, event venues, pickup points, and return destinations."
},
{
"name": "50 Seater AC Bus Shirdi",
"description": "50 Seater AC Bus Shirdi offers spacious air-conditioned transportation for large groups traveling over short or long distances. It is suitable for sightseeing, family tours, corporate programs, weddings, pilgrimages, school trips, and event-related transportation."
},
{
"name": "50 Seater Luxury Bus Shirdi",
"description": "50 Seater Luxury Bus Shirdi is an option for groups looking for a comfortable and premium travel experience. The large-capacity vehicle can be arranged for corporate tours, family vacations, weddings, special events, sightseeing programs, and outstation journeys."
},
{
"name": "50 Seater Bus One Way Shirdi",
"description": "50 Seater Bus One Way Shirdi is convenient for groups traveling from Shirdi to another destination without requiring a return service. The journey can be scheduled according to the desired departure time, route, destination, passenger count, and luggage requirements."
},
{
"name": "50 Seater Bus Round Trip Shirdi",
"description": "50 Seater Bus Round Trip Shirdi is suitable for groups planning both onward and return transportation from Shirdi. It works well for family vacations, sightseeing tours, pilgrimages, corporate outings, weddings, events, and multi-day group travel."
},
{
"name": "50 Seater Bus Airport Transfer Shirdi",
"description": "50 Seater Bus Airport Transfer Shirdi provides a convenient group transportation option between Shirdi and nearby airports. It is useful for tour groups, families, corporate teams, and organized travelers who need coordinated airport pickup or drop service with sufficient seating and luggage space."
},
{
"name": "affordable 50 Seater Bus Rental Shirdi",
"description": "Affordable 50 Seater Bus Rental Shirdi offers a practical way for large groups to travel together while planning transportation according to their budget and itinerary. Rental arrangements can be customized based on route, distance, travel duration, passenger needs, and one-way or round-trip requirements."
},
{
"name": "best 50 Seater Bus Hire Shirdi",
"description": "Best 50 Seater Bus Hire Shirdi is suitable for travelers searching for spacious and convenient group transportation in Shirdi. The service can support family tours, corporate trips, weddings, school excursions, pilgrimages, sightseeing, airport transfers, events, and outstation journeys."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 50 seater bus rental and group transportation services in Shirdi for local and outstation travel. Customers can arrange suitable buses for family trips, pilgrimages, weddings, corporate programs, school tours, sightseeing, events, airport transfers, and customized group journeys."
}
],
"tableData": [
["50 Seater Bus on Rent in Shirdi", "50 Seater Bus Rental Shirdi"],
["50 Seater Bus Hire Shirdi", "50 Seater Tourist Bus Shirdi"],
["50 Seater Bus Booking Shirdi", "50 Seater Bus with Driver Shirdi"],
["50 Seater Bus for Outstation Shirdi", "50 Seater Bus for Family Trip Shirdi"],
["50 Seater Bus for Wedding Shirdi", "50 Seater Bus for Corporate Trip Shirdi"],
["50 Seater Bus for School Trip Shirdi", "50 Seater Bus for Pilgrimage Shirdi"],
["50 Seater Bus for Events Shirdi", "50 Seater AC Bus Shirdi"],
["50 Seater Luxury Bus Shirdi", "50 Seater Bus One Way Shirdi"],
["50 Seater Bus Round Trip Shirdi", "50 Seater Bus Airport Transfer Shirdi"],
["affordable 50 Seater Bus Rental Shirdi", "best 50 Seater Bus Hire Shirdi"],
["Sai Shirdi Cabs", "50 Seater Bus on Rent in Shirdi"]
]
,







whychoose: [  

    {   

        WhyChooseheading: "50 Seater Bus on Rent in Shirdi for Large Group Travel",   

        WhyChoosedescription: "Sai Shirdi Cabs provides 50 Seater Bus rental services in Shirdi for large pilgrimage groups, families, tourists, school and college groups, corporate teams, wedding guests, and other large groups. A 50 Seater Bus can be arranged for Sai Baba Darshan, Shirdi sightseeing, religious tours, events, airport and railway station transfers, outstation journeys, and multi-day group travel."   

    },   

    {   

        WhyChooseheading: "Spacious 50 Seater Bus Rental for Group Transportation",   

        WhyChoosedescription: "A 50 Seater Bus provides a convenient transportation option for large groups travelling together in and around Shirdi. Instead of arranging several smaller vehicles, groups can coordinate their journey through one larger bus for hotel transfers, temple visits, sightseeing programs, events, railway station pickups, airport transfers, and planned outstation travel."   

    },   

    {   

        WhyChooseheading: "50 Seater Bus for Sai Baba Darshan in Shirdi",   

        WhyChoosedescription: "Pilgrimage groups visiting Shirdi can rent a 50 Seater Bus for Sai Baba Darshan and other religious visits. The bus can be used to coordinate transportation for devotees travelling together between their accommodation, temple areas, parking locations, railway station, and other planned pilgrimage destinations during their Shirdi visit."   

    },   

    {   

        WhyChooseheading: "50 Seater Bus for Shirdi Sightseeing Tours",   

        WhyChoosedescription: "Tourists and family groups can hire a 50 Seater Bus for sightseeing in Shirdi and nearby destinations. The travel plan can include religious attractions, local sightseeing points, nearby pilgrimage locations, and other places selected by the group, making it suitable for organized day tours and longer sightseeing schedules."   

    },   

    {   

        WhyChooseheading: "50 Seater Bus for Railway Station & Airport Transfers",   

        WhyChoosedescription: "Sai Shirdi Cabs can arrange 50 Seater Bus transportation for large groups requiring railway station or airport pickup and drop services. Group transfers can be planned according to arrival and departure schedules, passenger requirements, luggage needs, hotel locations, and other destinations included in the travel itinerary."   

    },   

    {   

        WhyChooseheading: "50 Seater Bus Rental for Weddings and Events",   

        WhyChoosedescription: "A 50 Seater Bus can be rented in Shirdi for weddings, receptions, religious functions, corporate events, family gatherings, conferences, and other group occasions. Event organizers can use the bus to coordinate guest transportation between hotels, venues, railway stations, parking areas, and other locations according to the planned event schedule."   

    },   

    {   

        WhyChooseheading: "50 Seater Bus for Outstation Trips from Shirdi",   

        WhyChoosedescription: "Large groups can book a 50 Seater Bus from Shirdi for outstation journeys to cities, tourist destinations, and pilgrimage locations such as Nashik, Mumbai, Pune, Trimbakeshwar, Shani Shingnapur, Chhatrapati Sambhajinagar, and other destinations. It can be suitable for family tours, religious circuits, school trips, corporate outings, and multi-city travel plans."   

    },   

    {   

        WhyChooseheading: "Book 50 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs",   

        WhyChoosedescription: "To arrange a 50 Seater Bus in Shirdi, provide Sai Shirdi Cabs with your pickup location, destination, travel date, number of passengers, luggage requirements, rental duration, sightseeing plans, and one-way or round-trip requirement. Based on the complete travel details, the bus rental can be planned according to your group's transportation needs."   

    }   

]   


}; 

const faqData = [ 

{ 

question: "Can I rent a 50 Seater Bus in Shirdi?", 

answer: "Yes, Sai Shirdi Cabs provides 50 Seater Bus rental services in Shirdi for pilgrimage groups, families, tourists, corporate teams, wedding guests, school groups, and other large groups." 

}, 

{ 

question: "Is a 50 Seater Bus suitable for Sai Baba Darshan?", 

answer: "Yes, a 50 Seater Bus can be arranged for large groups visiting Sai Baba Temple and nearby religious destinations according to their planned travel schedule." 

}, 

{ 

question: "Can I book a 50 Seater Bus for Shirdi sightseeing?", 

answer: "Yes, groups can book a 50 Seater Bus for Shirdi sightseeing and nearby attractions based on their preferred destinations, travel duration, and sightseeing itinerary." 

}, 

{ 

question: "Can I book a 50 Seater Bus for airport pickup and drop?", 

answer: "Yes, a 50 Seater Bus can be arranged for airport pickup and drop services for large groups according to flight timings, passenger requirements, luggage, and the required transfer locations." 

}, 

{ 

question: "Can I get a 50 Seater Bus from Shirdi Railway Station?", 

answer: "Yes, Sai Shirdi Cabs can arrange group transportation from Shirdi Railway Station using a 50 Seater Bus according to train arrival or departure schedules and the group's destination." 

}, 

{ 

question: "Can I rent a 50 Seater Bus for a wedding in Shirdi?", 

answer: "Yes, a 50 Seater Bus can be booked for wedding guests, family members, receptions, religious functions, and other event-related transportation requirements in Shirdi." 

}, 

{ 

question: "Can I use a 50 Seater Bus for an outstation trip from Shirdi?", 

answer: "Yes, a 50 Seater Bus can be used for outstation group travel from Shirdi to different cities, tourist destinations, pilgrimage places, and other locations based on the planned route." 

}, 

{ 

question: "Can I rent a 50 Seater Bus for multiple days?", 

answer: "Yes, multi-day 50 Seater Bus rental can be arranged for extended pilgrimage tours, family vacations, sightseeing trips, corporate tours, school excursions, religious circuits, and multi-city journeys." 

}, 

{ 

question: "Can a 50 Seater Bus be booked for corporate travel?", 

answer: "Yes, companies can use a 50 Seater Bus for corporate events, employee group transportation, conferences, meetings, business tours, company outings, and other organized group travel requirements." 

}, 

{ 

question: "How can I book a 50 Seater Bus on Rent in Shirdi?", 

answer: "You can contact Sai Shirdi Cabs with your pickup point, destination, travel date, passenger count, luggage details, rental duration, sightseeing or event requirements, and one-way or return preference to arrange the 50 Seater Bus service." 

} 

]; 

const testimonials = [ 

{ 

id: 1, 

name: "Mr. Rahul Deshmukh", 

feedback: "We rented a 50 Seater Bus in Shirdi for our pilgrimage group and used it for Sai Baba Darshan and nearby sightseeing. Having everyone travel together made the entire journey easier to coordinate and helped our group stay organized throughout the trip.", 

rating: 5 

}, 

{ 

id: 2, 

name: "Mrs. Sneha Kulkarni", 

feedback: "Our extended family booked a 50 Seater Bus for an event in Shirdi. The larger vehicle was convenient for transporting guests between the hotel, venue, railway station, and other planned locations without needing to coordinate several separate cars.", 

rating: 5 

} 

];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/50-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book a 50 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. Our 50 Seater Bus is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimages, weddings, corporate trips, school trips, airport transfers, railway station transfers, and outstation travel. Get a well-maintained bus with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/50-seater-bus-on-rent-in-shirdi"
  }
};




    return (
        <div>


<Helmet>
  <title>50 Seater Bus on Rent in Shirdi | 50 Seater Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 50 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, weddings, corporate trips, school trips and outstation journeys. Get a spacious bus with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="50 Seater Bus on Rent in Shirdi, 50 Seater Bus Rental Shirdi, 50 Seater Bus Hire Shirdi, 50 Seater Tourist Bus Shirdi, 50 Seater Bus Booking Shirdi, 50 Seater Bus with Driver Shirdi, 50 Seater Bus for Outstation Shirdi, 50 Seater Bus for Family Trip Shirdi, 50 Seater Bus for Wedding Shirdi, 50 Seater Bus for Corporate Trip Shirdi, 50 Seater Bus for School Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Fiveseaterbusonrentinshirdi;